import { Component } from '@angular/core';

@Component({
  selector: 'app-search-icon',
  imports: [],
  standalone: true,
  templateUrl: './search-icon.component.svg',
})
export class SearchIconComponent {}
